import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  ListGroup,
  Col,
  Card,
  Row,
  Container,
} from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { debounce } from "lodash";
import { useAuth } from "../../../Utils/Auth";
import { customErrorHandler, toTitleCase } from "../../../Utils/helper";
import FullScreenLoader from "../../../Component/FullScreenLoader";
import "./index.css";
import { CreateUserSchema } from "../../../Services/schema";
import userService from "../../../Services/apiService/user-service";
import introducerService from "../../../Services/apiService/introducer-service";

const RenderIntroducerDropdown = ({
  introducerState,
  fieldName,
  handleIntroducerSetState,
}) => {
  return (
    <ListGroup className="introducer-dropdown">
      {introducerState.searchedResult.length > 0 ? (
        introducerState.searchedResult.map((option, index) => (
          <ListGroup.Item
            key={index}
            action
            onClick={() => handleIntroducerSetState(option.userName, fieldName)}
          >
            {option.userName}
          </ListGroup.Item>
        ))
      ) : (
        <ListGroup.Item className="text-muted">No Results Found</ListGroup.Item>
      )}
    </ListGroup>
  );
};

const CreateUser = () => {
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const introducerInitialValues = {
    searchIntroducer_1: "",
    searchIntroducer_2: "",
    searchIntroducer_3: "",
    searchedResult: [],
    introducerName_1: "",
    introducerName_2: "",
    introducerName_3: "",
    introducerName_1_dropDownVisible: false,
    introducerName_2_dropDownVisible: false,
    introducerName_3_dropDownVisible: false,
    introducerNameError_1: "",
    introducerNameError_2: "",
    introducerNameError_3: "",
  };
  const [introducerState, setIntroducerState] = useState(introducerInitialValues);
  const initialValues = {
    firstName: "",
    userName: "",
    lastName: "",
    password: "",
    confirmPassword: "",
    contactNumber: "",
    introducersUserName1: "",
    introducersUserName2: "",
    introducersUserName3: "",
    introducerPercentage1: "",
    introducerPercentage2: "",
    introducerPercentage3: "",
  };

  const handleIntroducerChange = (e) => {
    const { name, value } = e.target;
    setIntroducerState((state) => ({
      ...state,
      [name]: value,
    }));
  };

  const debouncedIntroducerSearch = debounce((searchText) => {
    introducerService
      .searchIntroducerList(auth.user, searchText)
      .then((res) => {
        setIntroducerState((state) => ({
          ...state,
          searchedResult: res?.data?.data,
        }));
      })
      .catch((err) => {
        toast.error(customErrorHandler(err));
      });
  }, 300);

  useEffect(() => {
    const serachValue =
      introducerState.searchIntroducer_1 ||
      introducerState.searchIntroducer_2 ||
      introducerState.searchIntroducer_3;
    if (serachValue) {
      debouncedIntroducerSearch(serachValue);
    }

    return () => {
      debouncedIntroducerSearch.cancel();
    };
  }, [
    introducerState.searchIntroducer_1,
    introducerState.searchIntroducer_2,
    introducerState.searchIntroducer_3,
  ]);

  const handleSubmit = (values, { resetForm }) => {
    const value = {
      ...values,
      introducersUserName1: introducerState.introducerName_1,
      introducersUserName2: introducerState.introducerName_2,
      introducersUserName3: introducerState.introducerName_3,
      introducerPercentage1: parseFloat(values.introducerPercentage1),
      introducerPercentage2: parseFloat(values.introducerPercentage2),
      introducerPercentage3: parseFloat(values.introducerPercentage3)
    };

    if (value.password === value.confirmPassword) {
      setIsLoading(true);
      userService
        .createNewUser(value, auth.user)
        .then((res) => {
          toast.success(toTitleCase(res?.data?.message));
          resetForm({ values: initialValues });
          setIntroducerState(introducerInitialValues);
        })
        .catch((err) => {
          toast.error(customErrorHandler(err));
        });
    } else {
      toast.error(toTitleCase("Password and Confirm Password Should be Same"));
    }
    setIsLoading(false);
  };

  const handleIntroducerSetState = (value, introducer) => {
    switch (introducer) {
      case "introducerName_1":
        if (
          value !== introducerState.introducerName_2 &&
          value !== introducerState.introducerName_3
        ) {
          setIntroducerState((state) => ({
            ...state,
            searchIntroducer_1: value,
            introducerName_1: value,
            introducerNameError_1: "",
            introducerName_1_dropDownVisible: false,
            searchedResult: [],
          }));
        } else {
          setIntroducerState((state) => ({
            ...state,
            searchIntroducer_1: "",
            introducerNameError_1: toTitleCase(
              "Same Introducer Already Assigned"
            ),
            introducerName_1_dropDownVisible: false,
            searchedResult: [],
          }));
        }
        break;
      case "introducerName_2":
        if (
          value !== introducerState.introducerName_1 &&
          value !== introducerState.introducerName_3
        ) {
          setIntroducerState((state) => ({
            ...state,
            searchIntroducer_2: value,
            introducerName_2: value,
            introducerNameError_2: "",
            introducerName_2_dropDownVisible: false,
            searchedResult: [],
          }));
        } else {
          setIntroducerState((state) => ({
            ...state,
            searchIntroducer_2: "",
            introducerNameError_2: toTitleCase(
              "Same Introducer Already Assigned"
            ),
            introducerName_1_dropDownVisible: false,
            searchedResult: [],
          }));
        }
        break;
      case "introducerName_3":
        if (
          value !== introducerState.introducerName_1 &&
          value !== introducerState.introducerName_2
        ) {
          setIntroducerState((state) => ({
            ...state,
            searchIntroducer_3: value,
            introducerNameError_3: "",
            introducerName_3: value,
            introducerName_3_dropDownVisible: false,
            searchedResult: [],
          }));
        } else {
          setIntroducerState((state) => ({
            ...state,
            searchIntroducer_3: "",
            introducerNameError_3: toTitleCase(
              "Same Introducer Already Assigned"
            ),
            introducerName_1_dropDownVisible: false,
            searchedResult: [],
          }));
        }
        break;
    }
  };

  const handleIntroducerDropdownOpen = (isVisible, field) => {
    setIntroducerState((state) => ({
      ...state,
      [field]: isVisible,
    }));
    if (isVisible) {
      if (field === "introducerName_1_dropDownVisible") {
        setIntroducerState((state) => ({
          ...state,
          introducerNameError_1: "",
        }));
      } else if (field === "introducerName_2_dropDownVisible") {
        setIntroducerState((state) => ({
          ...state,
          introducerNameError_2: "",
        }));
      }
      else {
        setIntroducerState((state) => ({
          ...state,
          introducerNameError_1: "",
        }));
      }
    }
  };

  return (
    <Container fluid className="create-user-container">
      <FullScreenLoader show={isLoading} />
      <Card className="form-card">
        <Card.Body>
          <h2 className="form-title">Create New User</h2>
          <Formik
            initialValues={initialValues}
            validationSchema={CreateUserSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched, handleSubmit }) => (
              <Form>
                <Row className="g-3">
                  {/* User Name */}
                  <Col md={6} lg={4}>
                    <Form.Group controlId="userName">
                      <Form.Label>
                        Username <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        as={Form.Control}
                        type="text"
                        name="userName"
                        placeholder="Enter Username"
                        className={
                          touched.userName && errors.userName
                            ? "is-invalid"
                            : ""
                        }
                      />
                      <ErrorMessage
                        name="userName"
                        component="div"
                        className="invalid-feedback"
                      />
                    </Form.Group>
                  </Col>

                  {/* Password */}
                  <Col md={6} lg={4}>
                    <Form.Group controlId="password">
                      <Form.Label>
                        Password <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        as={Form.Control}
                        type="password"
                        name="password"
                        placeholder="Create Password"
                        className={
                          touched.password && errors.password
                            ? "is-invalid"
                            : ""
                        }
                      />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="invalid-feedback"
                      />
                    </Form.Group>
                  </Col>

                  {/* Confirm Password */}
                  <Col md={6} lg={4}>
                    <Form.Group controlId="confirmPassword">
                      <Form.Label>
                        Confirm Password{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        as={Form.Control}
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm Password"
                        className={
                          touched.confirmPassword && errors.confirmPassword
                            ? "is-invalid"
                            : ""
                        }
                      />
                      <ErrorMessage
                        name="confirmPassword"
                        component="div"
                        className="invalid-feedback"
                      />
                    </Form.Group>
                  </Col>

                  {/* First Name */}
                  <Col md={6} lg={4}>
                    <Form.Group controlId="firstName">
                      <Form.Label>
                        First Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        as={Form.Control}
                        type="text"
                        name="firstName"
                        placeholder="Enter First Name"
                        className={
                          touched.firstName && errors.firstName
                            ? "is-invalid"
                            : ""
                        }
                      />
                      <ErrorMessage
                        name="firstName"
                        component="div"
                        className="invalid-feedback"
                      />
                    </Form.Group>
                  </Col>

                  {/* Last Name */}
                  <Col md={6} lg={4}>
                    <Form.Group controlId="lastName">
                      <Form.Label>
                        Last Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        as={Form.Control}
                        type="text"
                        name="lastName"
                        placeholder="Enter Last Name"
                        className={
                          touched.lastName && errors.lastName
                            ? "is-invalid"
                            : ""
                        }
                      />
                      <ErrorMessage
                        name="lastName"
                        component="div"
                        className="invalid-feedback"
                      />
                    </Form.Group>
                  </Col>

                  {/* Contact Number */}
                  <Col md={6} lg={4}>
                    <Form.Group controlId="contactNumber">
                      <Form.Label>
                        Contact Number{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        as={Form.Control}
                        type="text"
                        name="contactNumber"
                        placeholder="Phone Number"
                        className={
                          touched.contactNumber && errors.contactNumber
                            ? "is-invalid"
                            : ""
                        }
                      />
                      <ErrorMessage
                        name="contactNumber"
                        component="div"
                        className="invalid-feedback"
                      />
                    </Form.Group>
                  </Col>

                  {/* Introducer Fields */}
                  <Col md={6} lg={4}>
                    <Form.Group
                      controlId="introducersUserName1"
                      className="introducer-group"
                    >
                      <Form.Label>Introducer Name</Form.Label>
                      <Field
                        as={Form.Control}
                        type="text"
                        name="searchIntroducer_1"
                        placeholder="Search Introducer"
                        autoComplete="off"
                        onChange={(e) => {
                          handleIntroducerChange(e);
                        }}
                        onFocus={() =>
                          handleIntroducerDropdownOpen(
                            true,
                            "introducerName_1_dropDownVisible"
                          )
                        }
                        onBlur={() => {
                          setTimeout(() => {
                            handleIntroducerDropdownOpen(
                              false,
                              "introducerName_1_dropDownVisible"
                            );
                          }, 150);
                        }}
                        value={
                          introducerState.searchIntroducer_1 
                        }
                      />
                      {introducerState.introducerNameError_1 && <span className="text-danger" style={{ fontSize: '14px' }}>{introducerState.introducerNameError_1}</span>}
                      {introducerState.introducerName_1_dropDownVisible && (
                        <RenderIntroducerDropdown
                          introducerState={introducerState}
                          fieldName={"introducerName_1"}
                          handleIntroducerSetState={
                            handleIntroducerSetState
                          }
                        />
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6} lg={4}>
                    <Form.Group
                      controlId="introducersUserName2"
                      className="introducer-group"
                    >
                      <Form.Label>Introducer Name (2)</Form.Label>
                      <Field
                        as={Form.Control}
                        type="text"
                        name="searchIntroducer_2"
                        placeholder="Search Introducer"
                        autoComplete="off"
                        onChange={(e) => {
                          handleIntroducerChange(e);
                        }}
                        value={
                          introducerState.searchIntroducer_2 
                        }
                        onFocus={() =>
                          handleIntroducerDropdownOpen(
                            true,
                            "introducerName_2_dropDownVisible"
                          )
                        }
                        onBlur={() => {
                          setTimeout(() => {
                            handleIntroducerDropdownOpen(
                              false,
                              "introducerName_2_dropDownVisible"
                            );
                          }, 150);
                        }}
                      />
                      {introducerState.introducerNameError_2 && <span className="text-danger" style={{ fontSize: '14px' }}>{introducerState.introducerNameError_2}</span>}
                      {introducerState.introducerName_2_dropDownVisible && (
                        <RenderIntroducerDropdown
                          introducerState={introducerState}
                          fieldName={"introducerName_2"}
                          handleIntroducerSetState={
                            handleIntroducerSetState
                          }
                        />
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6} lg={4}>
                    <Form.Group
                      controlId="introducersUserName3"
                      className="introducer-group"
                    >
                      <Form.Label>Introducer Name (3)</Form.Label>
                      <Field
                        as={Form.Control}
                        type="text"
                        name="searchIntroducer_3"
                        placeholder="Search Introducer"
                        autoComplete="off"
                        onChange={(e) => {
                          handleIntroducerChange(e);
                        }}
                        value={
                          introducerState.searchIntroducer_3
                        }
                        onFocus={() =>
                          handleIntroducerDropdownOpen(
                            true,
                            "introducerName_3_dropDownVisible"
                          )
                        }
                        onBlur={() => {
                          setTimeout(() => {
                            handleIntroducerDropdownOpen(
                              false,
                              "introducerName_3_dropDownVisible"
                            );
                          }, 150);
                        }}
                      />
                      {introducerState.introducerNameError_3 && <span className="text-danger" style={{ fontSize: '14px' }}>{introducerState.introducerNameError_3}</span>}
                      {introducerState.introducerName_3_dropDownVisible && (
                        <RenderIntroducerDropdown
                          introducerState={introducerState}
                          fieldName={"introducerName_3"}
                          handleIntroducerSetState={
                            handleIntroducerSetState
                          }
                        />
                      )}
                    </Form.Group>
                  </Col>

                  {/* Percentage Fields */}
                  <Col md={4}>
                    <Form.Group controlId="introducerPercentage1">
                      <Form.Label>Introducer Percentage</Form.Label>
                      <Field
                        as={Form.Control}
                        type="number"
                        name="introducerPercentage1"
                        placeholder="Enter Percentage %"
                        className={
                          touched.introducerPercentage1 && errors.introducerPercentage1
                            ? "is-invalid"
                            : ""
                        }
                        disabled = {!introducerState.introducerName_1}
                      />
                      <ErrorMessage
                        name="introducerPercentage1"
                        component="div"
                        className="invalid-feedback"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group controlId="introducerPercentage2">
                      <Form.Label>Introducer Percentage (2)</Form.Label>
                      <Field
                        as={Form.Control}
                        type="number"
                        name="introducerPercentage2"
                        placeholder="Enter Percentage %"
                        className={
                          touched.introducerPercentage2 && errors.introducerPercentage2
                            ? "is-invalid"
                            : ""
                        }
                        disabled = {!introducerState.introducerName_2}
                      />
                      <ErrorMessage
                        name="introducerPercentage2"
                        component="div"
                        className="invalid-feedback"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group controlId="introducerPercentage3">
                      <Form.Label>Introducer Percentage (3)</Form.Label>
                      <Field
                        as={Form.Control}
                        type="number"
                        name="introducerPercentage3"
                        placeholder="Enter Percentage %"
                        className={
                          touched.introducerPercentage3 && errors.introducerPercentage3
                            ? "is-invalid"
                            : ""
                        }
                        disabled = {!introducerState.introducerName_3}
                      />
                      <ErrorMessage
                        name="introducerPercentage3"
                        component="div"
                        className="invalid-feedback"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-grid mt-4">
                  <Button
                    variant="primary"
                    type="submit"
                    size="lg"
                    className="submit-button mb-3"
                    onClick={handleSubmit}
                  >
                    Create User
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CreateUser;